import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navigation from "@/components/Navigation";
import WikiStateGrid from "@/components/WikiStateGrid";
import Breadcrumbs from "@/components/Breadcrumbs";
import Footer from "@/components/Footer";

const stateData: Record<string, any> = {
  AL: {
    name: "Alabama",
    code: "AL",
    responseTime: "5-7 business days",
    exemptions: 8,
    successRate: 72,
  },
  AK: {
    name: "Alaska",
    code: "AK",
    responseTime: "7-10 business days",
    exemptions: 9,
    successRate: 68,
  },
  AZ: {
    name: "Arizona",
    code: "AZ",
    responseTime: "5 business days",
    exemptions: 7,
    successRate: 76,
  },
  AR: {
    name: "Arkansas",
    code: "AR",
    responseTime: "5 business days",
    exemptions: 8,
    successRate: 71,
  },
  CA: {
    name: "California",
    code: "CA",
    responseTime: "14 calendar days",
    exemptions: 12,
    successRate: 81,
  },
  CO: {
    name: "Colorado",
    code: "CO",
    responseTime: "3 business days",
    exemptions: 7,
    successRate: 79,
  },
  CT: {
    name: "Connecticut",
    code: "CT",
    responseTime: "4 business days",
    exemptions: 9,
    successRate: 75,
  },
  DE: {
    name: "Delaware",
    code: "DE",
    responseTime: "15 business days",
    exemptions: 8,
    successRate: 70,
  },
  FL: {
    name: "Florida",
    code: "FL",
    responseTime: "3 business days",
    exemptions: 6,
    successRate: 82,
  },
  GA: {
    name: "Georgia",
    code: "GA",
    responseTime: "7 business days",
    exemptions: 9,
    successRate: 73,
  },
  HI: {
    name: "Hawaii",
    code: "HI",
    responseTime: "10 business days",
    exemptions: 8,
    successRate: 69,
  },
  ID: {
    name: "Idaho",
    code: "ID",
    responseTime: "5 business days",
    exemptions: 9,
    successRate: 71,
  },
  IL: {
    name: "Illinois",
    code: "IL",
    responseTime: "5 business days",
    exemptions: 8,
    successRate: 77,
  },
  IN: {
    name: "Indiana",
    code: "IN",
    responseTime: "15 days",
    exemptions: 9,
    successRate: 70,
  },
  IA: {
    name: "Iowa",
    code: "IA",
    responseTime: "10 business days",
    exemptions: 7,
    successRate: 74,
  },
  KS: {
    name: "Kansas",
    code: "KS",
    responseTime: "3 business days",
    exemptions: 8,
    successRate: 78,
  },
  KY: {
    name: "Kentucky",
    code: "KY",
    responseTime: "10 days",
    exemptions: 9,
    successRate: 69,
  },
  LA: {
    name: "Louisiana",
    code: "LA",
    responseTime: "3 business days",
    exemptions: 10,
    successRate: 66,
  },
  ME: {
    name: "Maine",
    code: "ME",
    responseTime: "5 business days",
    exemptions: 8,
    successRate: 75,
  },
  MD: {
    name: "Maryland",
    code: "MD",
    responseTime: "30 days",
    exemptions: 9,
    successRate: 68,
  },
  MA: {
    name: "Massachusetts",
    code: "MA",
    responseTime: "10 business days",
    exemptions: 9,
    successRate: 73,
  },
  MI: {
    name: "Michigan",
    code: "MI",
    responseTime: "5 business days",
    exemptions: 8,
    successRate: 76,
  },
  MN: {
    name: "Minnesota",
    code: "MN",
    responseTime: "5 business days",
    exemptions: 9,
    successRate: 79,
  },
  MS: {
    name: "Mississippi",
    code: "MS",
    responseTime: "1 business day",
    exemptions: 10,
    successRate: 64,
  },
  MO: {
    name: "Missouri",
    code: "MO",
    responseTime: "3 business days",
    exemptions: 9,
    successRate: 77,
  },
  MT: {
    name: "Montana",
    code: "MT",
    responseTime: "2 business days",
    exemptions: 8,
    successRate: 80,
  },
  NE: {
    name: "Nebraska",
    code: "NE",
    responseTime: "4 business days",
    exemptions: 8,
    successRate: 75,
  },
  NV: {
    name: "Nevada",
    code: "NV",
    responseTime: "15 days",
    exemptions: 7,
    successRate: 72,
  },
  NH: {
    name: "New Hampshire",
    code: "NH",
    responseTime: "5 business days",
    exemptions: 8,
    successRate: 76,
  },
  NJ: {
    name: "New Jersey",
    code: "NJ",
    responseTime: "7 business days",
    exemptions: 9,
    successRate: 71,
  },
  NM: {
    name: "New Mexico",
    code: "NM",
    responseTime: "15 days",
    exemptions: 9,
    successRate: 68,
  },
  NY: {
    name: "New York",
    code: "NY",
    responseTime: "20 business days",
    exemptions: 9,
    successRate: 70,
  },
  NC: {
    name: "North Carolina",
    code: "NC",
    responseTime: "5 business days",
    exemptions: 9,
    successRate: 74,
  },
  ND: {
    name: "North Dakota",
    code: "ND",
    responseTime: "7 business days",
    exemptions: 8,
    successRate: 72,
  },
  OH: {
    name: "Ohio",
    code: "OH",
    responseTime: "3 business days",
    exemptions: 8,
    successRate: 78,
  },
  OK: {
    name: "Oklahoma",
    code: "OK",
    responseTime: "5 business days",
    exemptions: 9,
    successRate: 70,
  },
  OR: {
    name: "Oregon",
    code: "OR",
    responseTime: "5 business days",
    exemptions: 8,
    successRate: 77,
  },
  PA: {
    name: "Pennsylvania",
    code: "PA",
    responseTime: "15 business days",
    exemptions: 9,
    successRate: 69,
  },
  RI: {
    name: "Rhode Island",
    code: "RI",
    responseTime: "3 business days",
    exemptions: 8,
    successRate: 76,
  },
  SC: {
    name: "South Carolina",
    code: "SC",
    responseTime: "3 business days",
    exemptions: 9,
    successRate: 72,
  },
  SD: {
    name: "South Dakota",
    code: "SD",
    responseTime: "3 business days",
    exemptions: 8,
    successRate: 75,
  },
  TN: {
    name: "Tennessee",
    code: "TN",
    responseTime: "10 business days",
    exemptions: 9,
    successRate: 70,
  },
  TX: {
    name: "Texas",
    code: "TX",
    responseTime: "10 business days",
    exemptions: 10,
    successRate: 65,
  },
  UT: {
    name: "Utah",
    code: "UT",
    responseTime: "3 business days",
    exemptions: 8,
    successRate: 79,
  },
  VT: {
    name: "Vermont",
    code: "VT",
    responseTime: "5 business days",
    exemptions: 8,
    successRate: 77,
  },
  VA: {
    name: "Virginia",
    code: "VA",
    responseTime: "5 business days",
    exemptions: 9,
    successRate: 73,
  },
  WA: {
    name: "Washington",
    code: "WA",
    responseTime: "5 business days",
    exemptions: 8,
    successRate: 78,
  },
  WV: {
    name: "West Virginia",
    code: "WV",
    responseTime: "5 business days",
    exemptions: 9,
    successRate: 71,
  },
  WI: {
    name: "Wisconsin",
    code: "WI",
    responseTime: "3 business days",
    exemptions: 8,
    successRate: 80,
  },
  WY: {
    name: "Wyoming",
    code: "WY",
    responseTime: "3 business days",
    exemptions: 8,
    successRate: 74,
  },
};

export default function StateFOIA() {
  const { state } = useParams<{ state: string }>();
  const navigate = useNavigate();
  const stateCode = state?.toUpperCase() || "";
  const data = stateData[stateCode];

  const [showFullStatute, setShowFullStatute] = useState(false);
  const [statuteText, setStatuteText] = useState<string | null>(null);
  const [loadingStatute, setLoadingStatute] = useState(false);

  const fetchStatuteText = async () => {
    if (statuteText) {
      setShowFullStatute(!showFullStatute);
      return;
    }

    setLoadingStatute(true);
    try {
      const response = await fetch(`/api/transparency/statute/${stateCode}`);
      if (!response.ok) throw new Error('Statute not found');

      const data = await response.json();
      setStatuteText(data.fullText);
      setShowFullStatute(true);
    } catch (error) {
      console.error('Failed to load statute:', error);
      alert('Full statute text not available in database yet.');
    } finally {
      setLoadingStatute(false);
    }
  };

  if (!data) {
    return (
      <div className="min-h-screen">
        <Navigation />
        <div className="w-full bg-brand-martinique min-h-[400px] flex items-center justify-center">
          <div className="text-center">
            <h1 className="font-agency text-h2 font-bold text-white mb-4">
              State Not Found
            </h1>
            <button
              onClick={() => navigate("/wiki")}
              className="px-6 py-3 bg-brand-orange text-white font-kepler font-bold rounded hover:bg-brand-orange/90 transition-colors"
            >
              Back to Wiki
            </button>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <Navigation />

      <div className="w-full bg-brand-martinique">
        <div className="max-w-[1440px] mx-auto px-8 pt-4">
          <Breadcrumbs
            items={[{ label: "Wiki", href: "/wiki" }, { label: data.name }]}
            variant="dark"
          />
        </div>

        <section className="w-full bg-brand-martinique py-12 lg:py-16 border-b border-black/10">
          <div className="max-w-[1440px] mx-auto px-8">
            <h1 className="font-agency text-h1 font-bold text-white mb-2">
              {data.name}
            </h1>
            <p className="font-kepler text-text-lg-custom text-brand-gray mb-8">
              Complete FOIA information for {data.name}
            </p>

            <div className="grid lg:grid-cols-4 gap-6">
              <div className="bg-brand-dark rounded-lg p-6 space-y-2 border border-brand-orange/20">
                <p className="text-brand-orange font-kepler text-xs font-bold uppercase">
                  Response Time
                </p>
                <p className="text-white font-kepler text-lg font-bold">
                  {data.responseTime}
                </p>
              </div>

              <div className="bg-brand-dark rounded-lg p-6 space-y-2 border border-brand-orange/20">
                <p className="text-brand-orange font-kepler text-xs font-bold uppercase">
                  Exemptions
                </p>
                <p className="text-white font-kepler text-lg font-bold">
                  {data.exemptions} exemptions
                </p>
              </div>

              <div className="bg-brand-dark rounded-lg p-6 space-y-2 border border-brand-orange/20">
                <p className="text-brand-orange font-kepler text-xs font-bold uppercase">
                  Success Rate
                </p>
                <p className="text-white font-kepler text-lg font-bold">
                  {data.successRate}%
                </p>
              </div>

              <div className="bg-brand-dark rounded-lg p-6 flex items-center justify-center border border-brand-orange/20">
                <a
                  href="/foia-generator"
                  className="px-4 py-2 bg-brand-azure text-white font-kepler font-bold rounded hover:bg-brand-azure/90 transition-colors text-center"
                >
                  Generate Request
                </a>
              </div>
            </div>

            {/* Statute Citation & Full Text Button */}
            <div className="mt-8 bg-brand-orange/10 border border-brand-orange/30 rounded-lg p-6">
              <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
                <div>
                  <h3 className="font-agency text-h4 font-bold text-white mb-2">
                    Governing Statute
                  </h3>
                  <p className="font-jetbrains text-sm text-brand-orange mb-1">
                    {data.name} Public Information Act
                  </p>
                  <p className="font-jetbrains text-xs text-brand-gray">
                    Citation: [State Code § XXX.XXX] {/* TODO: Add from Neon DB */}
                  </p>
                </div>
                <button
                  onClick={fetchStatuteText}
                  disabled={loadingStatute}
                  className="px-6 py-3 bg-brand-orange text-white font-kepler font-bold rounded hover:bg-brand-orange/90 transition-colors text-center whitespace-nowrap inline-flex items-center gap-2 disabled:opacity-50"
                >
                  {loadingStatute ? (
                    <>
                      <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                      </svg>
                      Loading...
                    </>
                  ) : (
                    <>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
                        {showFullStatute && <polyline points="9 11 12 14 22 4" />}
                      </svg>
                      {showFullStatute ? 'Hide' : 'View'} Full Statute Text
                    </>
                  )}
                </button>
              </div>

              {/* Full Statute Text - Expandable */}
              {showFullStatute && statuteText && (
                <div className="mt-6 bg-brand-dark border border-brand-orange/30 rounded-lg p-6 max-h-[600px] overflow-y-auto">
                  <h4 className="font-agency text-h5 font-bold text-white mb-4">
                    Complete Statute Text
                  </h4>
                  <div className="font-jetbrains text-xs text-brand-gray leading-relaxed whitespace-pre-wrap">
                    {statuteText}
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>

        <section className="w-full bg-brand-martinique py-12 lg:py-16 border-b border-black/10">
          <div className="max-w-[1440px] mx-auto px-8">
            <h2 className="font-agency text-h2 font-bold text-white mb-8">
              In-Depth Statute Analysis
            </h2>

            <div className="space-y-6">
              <div className="bg-brand-dark rounded-lg p-6 space-y-4 border border-brand-orange/20">
                <h3 className="font-agency text-h4 font-bold text-white">
                  Response Time Requirements
                </h3>
                <p className="font-kepler text-text-md-custom text-brand-gray">
                  {data.name}'s FOIA statute requires agencies to respond within
                  <span className="text-brand-orange font-bold">
                    {" "}
                    {data.responseTime}
                  </span>
                  . Agencies may request extensions in specific circumstances,
                  but the initial deadline is strict.
                </p>
              </div>

              <div className="bg-brand-dark rounded-lg p-6 space-y-4 border border-brand-orange/20">
                <h3 className="font-agency text-h4 font-bold text-white">
                  Common Exemptions
                </h3>
                <p className="font-kepler text-text-md-custom text-brand-gray mb-4">
                  {data.name}'s law allows agencies to withhold records in
                  <span className="text-brand-orange font-bold">
                    {" "}
                    {data.exemptions} categories
                  </span>
                  . However, exemptions are narrowly construed—agencies must
                  prove why records qualify for each exemption.
                </p>
                <ul className="space-y-2 pl-6 font-kepler text-text-md-custom text-brand-gray list-disc">
                  <li>National security & defense information</li>
                  <li>Privacy of individuals</li>
                  <li>Law enforcement investigations</li>
                  <li>Business confidential information</li>
                  <li>Privileged communications</li>
                </ul>
              </div>

              <div className="bg-brand-dark rounded-lg p-6 space-y-4 border border-brand-orange/20">
                <h3 className="font-agency text-h4 font-bold text-white">
                  Appeal Rights
                </h3>
                <p className="font-kepler text-text-md-custom text-brand-gray">
                  If your request is denied, {data.name}'s law provides appeal
                  rights. You can request an internal administrative appeal and,
                  in some cases, seek judicial review. Most denials can be
                  challenged effectively with the right strategy.
                </p>
              </div>

              <div className="bg-brand-dark rounded-lg p-6 space-y-4 border border-brand-orange/20">
                <h3 className="font-agency text-h4 font-bold text-white">
                  Success Rate
                </h3>
                <p className="font-kepler text-text-md-custom text-brand-gray mb-4">
                  Based on successful FOIA requests in {data.name}:
                </p>
                <div className="flex items-center gap-3">
                  <div className="flex-1 h-3 bg-brand-martinique rounded-full overflow-hidden">
                    <div
                      className="h-full bg-brand-orange"
                      style={{ width: `${data.successRate}%` }}
                    />
                  </div>
                  <span className="text-white font-kepler text-lg font-bold">
                    {data.successRate}%
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full bg-brand-martinique py-12 lg:py-16">
          <div className="max-w-[1440px] mx-auto px-8">
            <h2 className="font-agency text-h2 font-bold text-white mb-8">
              Next Steps
            </h2>

            <div className="grid lg:grid-cols-2 gap-8">
              <a
                href="/foia-generator"
                className="bg-brand-dark rounded-lg p-8 space-y-4 border border-brand-orange/20 hover:border-brand-orange/50 transition-colors group"
              >
                <h3 className="font-agency text-h4 font-bold text-white group-hover:text-brand-orange transition-colors">
                  Generate Your Request
                </h3>
                <p className="font-kepler text-text-md-custom text-brand-gray">
                  Use our AI-powered FOIA Generator to create an optimized
                  request for {data.name}.
                </p>
                <div className="text-brand-azure font-kepler font-bold">
                  Start Now →
                </div>
              </a>

              <a
                href="/wiki"
                className="bg-brand-dark rounded-lg p-8 space-y-4 border border-brand-orange/20 hover:border-brand-orange/50 transition-colors group"
              >
                <h3 className="font-agency text-h4 font-bold text-white group-hover:text-brand-orange transition-colors">
                  Back to Wiki
                </h3>
                <p className="font-kepler text-text-md-custom text-brand-gray">
                  Learn about other states or explore general FOIA principles.
                </p>
                <div className="text-brand-azure font-kepler font-bold">
                  Explore →
                </div>
              </a>
            </div>
          </div>
        </section>

        {/* Quick State Navigation */}
        <section className="w-full bg-brand-martinique py-12 border-t border-black/10">
          <div className="max-w-[1440px] mx-auto px-8">
            <h2 className="font-agency text-h3 font-bold text-white mb-6">
              Explore Other States
            </h2>
            <WikiStateGrid variant="dark" />
          </div>
        </section>

        <Footer />
      </div>
    </div>
  );
}
